import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { membersService } from '../api/members.service';
import { MEMBERS_KEYS } from './queryKeys';

/**
 * Toggles the active/inactive status of a member.
 * Calls PATCH /api/tenants/members/{memberId}/toggle.
 *
 * @remarks
 * On success, invalidates all member queries for the active organization
 * so the list reflects the updated status.
 */
export function useToggleMember() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ memberId, activate }: { memberId: string; activate: boolean }) =>
      membersService.toggle(memberId, { activate }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBERS_KEYS.byOrg(orgId) });
    },
  });
}
